import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { A } from '@osmosis/tailwind-ui/components/Text';
import { FooterColumn } from '../../../constants/footer';
import CollapsibleColumn from './CollapsibleColumn';

type Props = {
  columns: FooterColumn[];
};
const COLUMNS_PER_ROW = 3;

/**
 * Columns Component.
 */
const Columns = ({ columns }: Props) => {
  return (
    <Flex className="flex-1 flex-wrap">
      {columns.map((column, index) => {
        const header = column.items.find((item) => !item.href);
        const links = column.items.filter((item) => item.href);
        const isSecondRow = index >= COLUMNS_PER_ROW;

        return (
          <CollapsibleColumn
            key={index}
            title={header?.title ?? ''}
            className={isSecondRow ? 'md:mt-16' : ''}
            labels={header?.labels}
          >
            <ul className="m-0 mt-3 list-none p-0 md:space-y-3">
              {links.map(({ title, href }) => (
                <li key={title} className="mb-5 md:mb-0">
                  <A
                    className="text-wp-sand font-national-2 block text-sm font-normal  no-underline hover:text-white sm:leading-[1.6]"
                    href={href}
                    data-testid="footer-link"
                  >
                    {title}
                  </A>
                </li>
              ))}
            </ul>
          </CollapsibleColumn>
        );
      })}
    </Flex>
  );
};

export default Columns;
